import { BadgeCheck, ShieldAlert } from "lucide-react";

export const memberStanding = (m) => (m?.standing === "Good Standing" ? "Good Standing" : "Not in Good Standing");

export const StandingBanner = ({ member }) => {
  const good = memberStanding(member) === "Good Standing";
  return (
    <div role="status" data-testid="reg-standing-banner" data-good={good}
      className={`mb-4 inline-flex items-center gap-2.5 rounded-full border pl-1.5 pr-4 py-1.5 shadow-sm animate-in fade-in slide-in-from-top-1 duration-500 ${good ? "bg-emerald-50 border-emerald-200 text-emerald-800" : "bg-[#FFF0F0] border-[#E60000]/25 text-[#B30000]"}`}>
      <span className={`w-6 h-6 rounded-full grid place-items-center text-white ${good ? "bg-emerald-600" : "bg-[#E60000]"}`}>
        {good ? <BadgeCheck className="w-3.5 h-3.5" /> : <ShieldAlert className="w-3.5 h-3.5" />}
      </span>
      <span className="text-sm font-semibold tracking-tight">{good ? "Member in good standing" : "Member not in good standing"}</span>
    </div>
  );
};

export const StandingCard = ({ member }) => {
  const good = memberStanding(member) === "Good Standing";
  const ids = [member.gamls_id && `GAMLS ID ${member.gamls_id}`, member.staff_id && `Staff ID ${member.staff_id}`].filter(Boolean).join(" · ");
  return (
    <div className={`rounded-lg border p-4 sm:p-5 flex items-start gap-4 ${good ? "border-emerald-300 bg-emerald-50" : "border-[#E60000]/30 bg-[#FFF0F0]"}`} data-testid="my-standing-card">
      <div className={`w-11 h-11 shrink-0 rounded-md grid place-items-center ${good ? "bg-emerald-600 text-white" : "bg-[#E60000] text-white"}`}>
        {good ? <BadgeCheck className="w-6 h-6" /> : <ShieldAlert className="w-6 h-6" />}
      </div>
      <div className="min-w-0">
        <div className={`font-heading font-extrabold text-lg ${good ? "text-emerald-800" : "text-[#B30000]"}`} data-testid="my-standing-status">
          {good ? "Member in Good Standing" : "Member not in Good Standing"}
        </div>
        <p className="text-sm text-gray-600 mt-0.5">
          {good ? "Your ID matches the GAMLS membership master list." : ids ? "Your ID was not found on the GAMLS membership master list." : "No GAMLS ID or Staff ID is linked to your account."}
          {" "}{!good && "If you think this is wrong, please contact the GAMLS secretariat via Contact Us."}
        </p>
        {ids && <p className="text-xs font-mono text-gray-500 mt-1" data-testid="my-standing-ids">{ids}</p>}
      </div>
    </div>
  );
};
